<template>
 <div id="authorize-stage">
  <div class="header mt-5">
   <b class="text-3xl">Dê permissão ao {{appTitle}}.</b>
  </div>

  <div class="body mt-5">
   <div class="flex">
    <feather-icon icon="ExternalLinkIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Acesse novamente o popup clicando no botão 'Vincular', para conectar o seu celular.</p>
   </div>
   <div class="flex">
    <feather-icon icon="ListIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Na caixa de seleção 'Números' marque apenas um dos números que deseja vincular.</p>
   </div>
   <div class="flex">
    <feather-icon icon="SmileIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Clique em 'Salvar Seleção' e aguarde a notificação da plataforma.</p>
   </div>
  </div>
 </div>
</template>

<script>

export default {
 name: 'authorize-stage',
 data() {
  return {}
 },
 computed:{
  appTitle() {
   return process.env.VUE_APP_APP_TITLE || 'PedBot';
  }
 }
}

</script>

<style scoped lang="scss">

</style>